<script>

    import { afterUpdate, tick } from 'svelte'
    import { fade, slide } from 'svelte/transition'

    import { syncResponsiveLabels } from '../$methods/responsive.table.methods.js'

    import Spinner from './spinner.svelte'
    import Message from './message.svelte'

    export let items
    export let total
    export let loading = false

    export let headers = []
    export let rows = []
    export let expanded = null

    let tableEl

    function toggleRow(index) {
        expanded = index
    }

    afterUpdate(async () => {
        if (!tableEl || loading) return
        await tick()
        syncResponsiveLabels(tableEl)
    })

</script>

{#if items}
    <small>
        { items }
        {#if total}
            / {total}
        {/if}
        Resultados
    </small>
{/if}

<Spinner { loading } />
<Message show={!loading && !items} />

{#if !loading && items}
    <div class="table-container" in:fade>
        <table bind:this={tableEl} class="table app-table is-fullwidth is-hoverable">
            <thead>
                <tr>
                    {#each headers as header}
                        <th>{header}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each rows as row, index }
                    <tr on:click={() => toggleRow(index)} on:dblclick={() => toggleRow(null)}>
                        {#each row as value, inerIndex}
                            {#if inerIndex < row.length-1}
                                <td>{value}</td>
                            {:else}
                                {#if index === expanded}
                                    <td in:slide colspan={headers.length}>
                                        <svelte:component this={value.component} {...value.props} />
                                    </td>
                                {/if}
                            {/if}
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}
